import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import {ActivatedRoute, Router} from '@angular/router';
import { EvkOption, MessageCrudService } from '@evomatik/evk-common';
import { EvkSecurityControlDataService } from '@evomatik/evk-seguridad';
import { throwError } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { EvkExpedienteModel } from '../../../../../../expediente/models/evk-expediente.model';
import { CatalogosService } from '../../../../../../expediente/services/catalogos.service';
import {
    EvkFirmaElectronicaDialogComponent
} from "../../../../../../firma/componentes/firma-electronica/evk-firma-electronica-dialog/evk-firma-electronica-dialog.component";
import { DiligenciaAsignacionComponent } from '../diligencia-asignacion/diligencia-asignacion.component';
import { MotivoRechazoComponent } from '../motivo-rechazo-component/motivo-rechazo.component';
import { EvkDiligenciaAceptarService } from '../services/evk-diligencia-aceptar.service';
import { EvkDiligenciaAutorizarService } from '../services/evk-diligencia-autorizar.service';
import { EvkDiligenciaEnviarService } from '../services/evk-diligencia-enviar.service';
import { EvkDiligenciaFinalizarEnviarService } from '../services/evk-diligencia-finalizar-enviar.service';
import { EvkDiligenciaFinalizarRequestService } from '../services/evk-diligencia-finalizar-request.service';
import { EvkDiligenciaFinalizarService } from '../services/evk-diligencia-finalizar.service';
import { EvkDiligenciaResponderService } from '../services/evk-diligencia-responder.service';
import { EvkDiligenciaUpdateService } from '../services/evk-diligencia-update.service';
import { SolicitarAutorizacionCreateComponent } from '../solicitar-autorizacion/solicitar-autorizacion-create/solicitar-autorizacion-create.component';
import {AuthUtils} from "@evomatik/evk-seguridad";
import { MotivoRechazoCreateComponent } from '../motivo-rechazo/motivo-rechazo-create/motivo-rechazo-create.component';
import { EnAutorizacionDiligenciaCreateComponent } from '../en-autorizacion-diligencia/en-autorizacion-diligencia-create/en-autorizacion-diligencia-create.component';
@Component({
    selector: 'lib-informacion-diligencia',
    templateUrl: './informacion-diligencia.component.html',
    styleUrls: ['./informacion-diligencia.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class InformacionDiligenciaComponent implements OnInit {
    @Input() expediente: EvkExpedienteModel;
    @Input() idDiligencia: string;
    public diligencia:any;
    public tareaDocument:any;
    public diligenciaConfig:any;
    public readonly: boolean= false;
    public diligenciaPadre:any;
    public organizacionUsuario;
    public multipleAut = false;

    public hash = 'sha1';
    public encode = 'hex';
    public message = 'Mensaje';
    public rfc = 'GAMA600504JP1';
    public datosFirma: any;
    //public idDiligencia = TipoExpedienteEnum.DILIGENCIA;
    public username = 'm.landa.ueidp';
    private signedMessageFirma: any;
    public datos = {
        nombreInterviniente: 'JUAN PEREZ PEREZ',
        leyendaTitulo: 'FIRMA TITULO',
        leyendaCuerpo: 'FIRMA CUERPO',
        documentoNombre: 'DOCUMENTO',
        persona: null,
    };

    public hashs: any = [
        {
            value: 'sha1',
            name: 'SHA1'
        },
        {
            value: 'sha256',
            name: 'SHA256'
        },
        {
            value: 'sha512',
            name: 'SHA512'
        },
        {
            value: 'md5',
            name: 'MD5'
        },
        {
            value: 'ripemd160',
            name: 'RIPEMD-160'
        },
        {
            value: 'aes',
            name: 'AES (no soportado)'
        }
    ];

    public encodes: any = [
        {
            value: 'hex',
            name: 'Hexadecimal'
        },
        {
            value: 'base64',
            name: 'Base 64'
        },
        {
            value: 'json',
            name: 'JSON (no soportado)'
        }
    ];

    constructor(
        public router: Router,
        public dialog: MatDialog,
        private catalogosService: CatalogosService,
        private evkSecurity: EvkSecurityControlDataService,
        public messageCrudService: MessageCrudService,
        private finalizarService: EvkDiligenciaFinalizarService,
        private evkDiligenciaUpdateService: EvkDiligenciaUpdateService,
        private evkDiligenciaFinalizarEnviarService: EvkDiligenciaFinalizarEnviarService,
        private finalizarRequestService: EvkDiligenciaFinalizarRequestService,
        private aceptarSolicitudService: EvkDiligenciaAceptarService,
        private route: ActivatedRoute,
        private evkDiligenciaEnviarService: EvkDiligenciaEnviarService,
        private evkResponderDiligenciaService: EvkDiligenciaResponderService,
        private evkDiligenciaAutorizarService: EvkDiligenciaAutorizarService
    ) {
    }

    ngOnInit(): void {
        this.username = this.evkSecurity.getgetTokenInfo().user_name;
        if(this.expediente.idDiligenciaPadre){
            this.catalogosService.getDiligencia(this.expediente.idDiligenciaPadre).subscribe(
                response => {
                    if (response != null) {
                        console.log('diligenciaPadre',response);
                        this.diligenciaPadre = response;
                    } else {
                        console.log('No se encontro ninguna diligencia');
                    }
                },
                () => {
                    console.log('Ocurrio un error al cargar la diligencia');
                }
            );
        }
        this.catalogosService.getDiligencia(this.idDiligencia).subscribe(
            response => {
                if (response != null) {
                    console.log('diligencia',response);
                    this.diligencia = response;
                    this.catalogosService.getDiligenciaConfigById(this.diligencia["idDiligenciaConfig"]).subscribe((diligenciaConfig) => {
                        this.diligenciaConfig = diligenciaConfig;
                    });
                } else {
                    console.log('No se encontro ninguna diligencia');
                }
            },
            () => {
                console.log('Ocurrio un error al cargar la diligencia');
            }
        );
        this.catalogosService.getTareaDocument(this.idDiligencia).subscribe(
            response => {
                if (response != null) {
                    console.log('tarea',response);
                    this.tareaDocument = response;
                } else {
                    console.log('No se encontro ninguna tarea para la diligencia');
                }
            },
            () => {
                console.log('Ocurrio un error al cargar la tarea de la diligencia');
            }
        );
        this.viewOpcMultipleAuto();
    }

    openDialogFirma() {
        this.datosFirma = {
            hash: this.hash,
            message: this.message,
            encode: this.encode,
            rfc: 'GAMA600504JP1',
            username: 'v.bonilla',
            idDiligencia: '26788'
        };

        const dialogRef = this.dialog.open(EvkFirmaElectronicaDialogComponent, {
            width: '650px',
            panelClass: 'create-component-dialog-firma-electronica',
            disableClose: true,
            data: {
                datos: this.datosFirma,
            },
        });
        dialogRef.afterClosed().subscribe((resp) => {
            if (resp) {
                console.log(resp);
            }
        });
    }

    valid($event: any) {
        console.log('valid');
    }

    signedMessage($event: any) {
        //Recibe el objeto de la validacion
        this.signedMessageFirma = $event;
    }

    errorMessage($event: any) {
        console.log('Error');
    }

    loading($event: any) {
    }

    guardarFirma($event: any) {
        console.log('Guardado');
    }

    mostrarBotonEnviar(){
        if(!this.diligencia || !this.tareaDocument || !this.diligenciaConfig){
            return false;
        }
        if(!this.readonly
            && this.diligenciaConfig
            && this.diligenciaConfig.clasificacionDiligencia?.tipo === 'SOLICITUD'
            && this.diligencia?.estadoTareaActivo?.estado?.nombre === 'POR ENVIAR'
            ){
            return true;
        }else{
            return false;
        }
    }

    enviarDiligencia() {
        const confirmDialog = this.messageCrudService.openConfirmDialog({
            warn: '¿Está seguro de enviar esta actuación?',
            goonbtn: 'Aceptar'
        });
        confirmDialog.componentInstance.resolveEvent.subscribe(() => {
            this.evkDiligenciaEnviarService.edit(this.diligencia).subscribe((response) => {
                this.messageCrudService.snackbarMessage('Actuación enviada de forma exitosa.');
                confirmDialog.close();
                this.router.navigate(['/diligencias']);
            }, error => {
                this.messageCrudService.snackbarSimpleError('No se ha podido enviar la actuación :' + error);
                confirmDialog.close();
            });
        });
    }

    rechazarSolicitud() {
        const dialogRef = this.dialog.open(MotivoRechazoComponent, {
            width: '900px',
            data: this.diligencia
        });
        dialogRef.afterClosed().subscribe(val => {
            if (val) {
                this.router.navigate(['/diligencias']);
            }
        });
    }

    canValidarAceptarRol() {
        return true;//AuthUtils.hasRol('RECEPTOR_TAREA') || true;//AuthUtils.hasRol('ADMINISTRADOR_BANDEJA_TAREAS');
    }

    canAceptarOrRechazar(): boolean {
        if(!this.diligencia || !this.tareaDocument || !this.diligenciaConfig){
            return false;
        }
        const idOrganizaciones = [];
        idOrganizaciones.push(this.evkSecurity.getUsuarioInfo().idOrgFisica);
        idOrganizaciones.push(this.evkSecurity.getUsuarioInfo().idOrgLogica);
        if (this.diligencia) {
            if (this.diligencia.estadoTareaActivo) {
                return this.diligencia.estadoTareaActivo
                    && this.diligencia.estadoTareaActivo.estado.nombre === 'EN ESPERA'
                    && this.canValidarAceptarRol()
                    &&
                    (
                        (
                            this.diligencia.tarea.usuarioAsignado === null
                            && this.tareaDocument.organizacion
                            && idOrganizaciones.includes(this.tareaDocument.organizacion.value)
                        )
                        ||
                        (
                            this.diligencia.estadoTareaActivo.usuarioAsignado
                            && this.diligencia.estadoTareaActivo.usuarioAsignado.value === this.username
                        )
                    );
            }
            return false;
        }
        return false;
    }

    aceptarSolicitud() {
        const confirmDialog = this.messageCrudService.openConfirmDialog({
            warn: '¿Está seguro de aceptar esta actuación?',
            goonbtn: 'Aceptar'
        });
        confirmDialog.componentInstance.resolveEvent.subscribe(() => {
            this.aceptarSolicitudService.edit(this.diligencia).subscribe((response) => {
                this.messageCrudService.snackbarMessage('Actuación aceptada de forma exitosa.');
                confirmDialog.close();
                this.router.navigate(['/diligencias']);
                //this.wizardEvents.setReadOnly(false);
            }, error => {
                this.messageCrudService.snackbarSimpleError('No se ha podido aceptar la actuación :' + error);
                confirmDialog.close();
            });
        });
    }

    canValidarFinalizarRol() {
        return true;//AuthUtils.hasRol('ASISTENTE_EJECUTOR_TAREA');
    }

    mostrarBotonFinalizar(){
        if(!this.diligencia || !this.tareaDocument || !this.diligenciaConfig){
            return false;
        }
        if(!this.readonly
            && this.diligenciaConfig
            && this.diligenciaConfig.clasificacionDiligencia?.tipo === 'SOLICITUD'
            && this.diligencia?.estadoTareaActivo?.estado?.nombre === 'CREADA'
            && this.canValidarFinalizarRol()
            && (
                !this.diligenciaConfig?.tipoOrganizacionAutorizador
                || this.diligenciaConfig?.tipoOrganizacionAutorizador.length === 0
                )
            ){
            return true;
        }else{
            return false;
        }
    }

    mostrarBotonFinalizarSimple(){
        if(!this.diligencia || !this.tareaDocument || !this.diligenciaConfig){
            return false;
        }
        if(!this.readonly
            && this.diligenciaConfig
            && this.diligenciaConfig.clasificacionDiligencia?.tipo === 'SIMPLE'
            && !(this.diligencia?.estadoTareaActivo?.estado?.nombre === 'POR AUTORIZAR')
            && !(this.diligencia?.estadoTareaActivo?.estado?.nombre === 'EN AUTORIZACIÓN')
            && (this.diligencia?.idDiligenciaPadre === null || this.diligencia?.estadoTareaActivo?.estado?.nombre === 'EN CORRECCIÓN')
            && this.canValidarFinalizarRol()
            ){
            return true;
        }else{
            return false;
        }
    }

    finalizarDiligencia() {
        if (this.diligenciaConfig.requiereFirmaE) {
            if (!this.evkSecurity.getUsuarioInfo().persona.rfc || this.evkSecurity.getUsuarioInfo().persona.rfc === '') {
                this.messageCrudService.snackbarMessage('El usuario no cuenta con RFC');
                return;
            }
            this.finalizarService.validCadenaOriginarRfc({...this.diligencia})
                .pipe(take(1))
                .subscribe((value: any) => {
                    this.showModalFirmaEAndExecuteAnyMethod(value, accion => this.confirmarFinalizar(), 'Diligencia');
                });
        } else {
            this.confirmarFinalizar();
        }
    }

    confirmarFinalizar() {
        const confirmDialog = this.messageCrudService.openConfirmDialog({
            warn: '¿Está seguro de finalizar esta actuación?',
            goonbtn: 'Finalizar'
        });
        confirmDialog.componentInstance.resolveEvent.subscribe(() => {
            this.finalizarRequestService.edit(this.diligencia).subscribe((response) => {
                this.messageCrudService.snackbarMessage('Actuación finalizada de forma exitosa.');
                confirmDialog.close();
                //this.wizardEvents.setReadOnly(true);
                this.router.navigate(['/diligencias']);
            }, error => {
                if(error.message){
                    if(error.message.includes('Problemas con la información con los siguientes mensajes:')){
                        this.messageCrudService.snackbarSimpleError('No se ha podido finalizar la actuación :' + error.message.replace('Problemas con la información con los siguientes mensajes:',''));
                    }else{
                        this.messageCrudService.snackbarSimpleError('No se ha podido finalizar la actuación :' + error.message);
                    }
                }else{
                    this.messageCrudService.snackbarSimpleError('No se ha podido finalizar la actuación :' + error);
                }

                confirmDialog.close();
            });


            // this.evkDiligenciaUpdateService.edit(this.diligencia).pipe(take(1)).subscribe(diligenciaActulizada => {
            //     this.finalizarRequestService.edit(this.diligencia).subscribe((response) => {
            //         this.messageCrudService.snackbarMessage('Actuación finalizada de forma exitosa.');
            //         confirmDialog.close();
            //         //this.wizardEvents.setReadOnly(true);
            //         this.router.navigate(['/diligencias']);
            //     }, error => {
            //         if(error.message){
            //             if(error.message.includes('Problemas con la información con los siguientes mensajes:')){
            //                 this.messageCrudService.snackbarSimpleError('No se ha podido finalizar la actuación :' + error.message.replace('Problemas con la información con los siguientes mensajes:',''));
            //             }else{
            //                 this.messageCrudService.snackbarSimpleError('No se ha podido finalizar la actuación :' + error.message);
            //             }
            //         }else{
            //             this.messageCrudService.snackbarSimpleError('No se ha podido finalizar la actuación :' + error);
            //         }

            //         confirmDialog.close();
            //     });
            // }, error => {
            //     let mensaje = '';
            //     if (error.message) {
            //         mensaje = error.message;
            //     } else {
            //         mensaje = error;
            //     }
            //     this.messageCrudService.snackbarSimpleError('Ocurrio un error al finalizar la actuación :' + mensaje);
            //     confirmDialog.close();
            // });
        });
    }

    finalizarAndEnviar(){
        if (this.diligenciaConfig.requiereFirmaE) {
            if (!this.evkSecurity.getUsuarioInfo().persona.rfc || this.evkSecurity.getUsuarioInfo().persona.rfc === '') {
                this.messageCrudService.snackbarMessage('El usuario no cuenta con RFC');
                return;
            }
            this.finalizarService.validCadenaOriginarRfc({...this.diligencia})
            .pipe(take(1))
            .subscribe((value: any) => {
                this.showModalFirmaEAndExecuteAnyMethod(value, accion => this.finalizarAndEnviarDiligencia(), 'Diligencia');
            });
        } else {
            this.finalizarAndEnviarDiligencia();
        }
    }

    canValidarFinalizarAndEnviarRol() {
        //return !this.roles.includes('ASISTENTE_EJECUTOR_TAREA');
        return true;
    }

    mostrarBotonFinalizarEnviar(){
        if(!this.diligencia || !this.tareaDocument || !this.diligenciaConfig){
            return false;
        }
        if(!this.readonly
            && this.diligenciaConfig
            && this.diligenciaConfig.clasificacionDiligencia?.tipo === 'SOLICITUD'
            && this.diligencia?.estadoTareaActivo?.estado?.nombre === 'CREADA'
            && this.canValidarFinalizarAndEnviarRol()
            && (
                !this.diligenciaConfig?.tipoOrganizacionAutorizador
                || this.diligenciaConfig?.tipoOrganizacionAutorizador.length === 0
                )
            ){
            return true;
        }else{
            return false;
        }
    }


    showModalFirmaEAndExecuteAnyMethod(datosFirma: any, metodoEjecutar: any, origen: string) {
        const dialogRef = this.dialog.open(EvkFirmaElectronicaDialogComponent, {
            width: '650px',
            panelClass: 'create-component-dialog-firma-electronica',
            disableClose: true,
            data: {
                datos: datosFirma,
            },
        });

        dialogRef.afterClosed().subscribe((dialogResponse) => {
            if (dialogResponse && dialogResponse.valid) {
                const responseFirma = dialogResponse.message;
                const dataFirmaE = this.finalizarService.buildDataFirmaE(responseFirma, origen);
                this.finalizarService.addFirmaToDiligencia(dataFirmaE, this.diligencia).subscribe(diligencia => {
                    metodoEjecutar();
                }, error => {
                    catchError(() => throwError('No se ha podido registrar la firma en la actuación.'));
                });
            } else {
                const message = dialogResponse && dialogResponse.message && dialogResponse.message.message ? dialogResponse.message.message : 'se cancelo la firma electronica';
                this.messageCrudService.snackbarMessage('La firma electrónica no es válida: ' + message);
            }
        });
    }

    finalizarAndEnviarDiligencia() {
        const confirmDialog = this.messageCrudService.openConfirmDialog({
            warn: '¿Está seguro de finalizar y enviar esta actuación?',
            goonbtn: 'Aceptar'
        });
        confirmDialog.componentInstance.resolveEvent.subscribe(() => {
            this.evkDiligenciaUpdateService.edit(this.diligencia).pipe(take(1)).subscribe(diligenciaActualizada => {
                this.evkDiligenciaFinalizarEnviarService.edit(this.diligencia).subscribe((response) => {
                    this.messageCrudService.snackbarMessage('Actuación enviada de forma exitosa.');
                    confirmDialog.close();
                    //this.wizardDiligenciaService.updateData(response.data);
                    //this.wizardEvents.setReadOnly(true);
                    //this.routing.navigateTo('/diligencia/usuario/page');
                    this.router.navigate(['/diligencias']);
                }, error => {
                    if(error.message){
                        this.messageCrudService.snackbarSimpleError('No se ha podido enviar la actuación :' + error.message);
                    }else{
                        this.messageCrudService.snackbarSimpleError('No se ha podido enviar la actuación :' + error);
                    }
                    confirmDialog.close();
                });
            }, error => {
                this.messageCrudService.snackbarSimpleError('Ocurrio un error al enviar la actuación :' + error);
                confirmDialog.close();
            });
        });
    }

    canValidarAsignarRol() {
        return true;//AuthUtils.hasRol('ADMINISTRADOR_BANDEJA_TAREAS');
    }

    canAsignar(): boolean {
        if(!this.diligencia || !this.tareaDocument || !this.diligenciaConfig){
            return false;
        }
        if (this.diligencia) {
            if (this.diligencia.estadoTareaActivo) {
                return this.diligencia.estadoTareaActivo
                && this.diligencia.estadoTareaActivo.estado.nombre === 'POR ATENDER'
                && this.canValidarAsignarRol();
            }
            return false;
        }
        return false;
    }


    asignarSolicitud(origen: string) {
        let peritos = false;
        const dialog = this.dialog.open(DiligenciaAsignacionComponent, {
            panelClass: 'asignacion-diligencia-dialog',
            width: '900px',
            data: {tarea: this.diligencia.tarea, origen: origen, peritos: peritos},
        });

        dialog.afterClosed().subscribe((result: EvkOption) => {
            if (result) {
                this.messageCrudService.snackbarMessage('La actuación fue asignada con éxito');
                this.router.navigate(['/diligencias']);
            }
        });
    }

    canValidarReasignarRol() {
        return true;//AuthUtils.hasRol('ADMINISTRADOR_BANDEJA_TAREAS');
    }

    canReasignar(): boolean {
        if(!this.diligencia || !this.tareaDocument || !this.diligenciaConfig){
            return false;
        }
        if (this.diligencia) {
            if (this.diligencia.estadoTareaActivo) {
                return this.diligencia.estadoTareaActivo &&
                    (this.diligencia.estadoTareaActivo.estado.nombre === 'ASIGNADA') &&
                    this.canValidarReasignarRol();
            }
            return false;
        }
        return false;
    }

    validarEstatusDiligencia() {
        const username = this.evkSecurity.getUsuarioInfo().username;
        // tslint:disable-next-line:max-line-length
        if (!this.expediente.idDiligenciaPadre
            && this.diligencia
            && this.diligencia.estadoTareaActivo
            && this.diligencia.estadoTareaActivo.estado.nombre === 'ASIGNADA'
            && this.diligencia.tarea.usuarioAsignado.value === username
            && this.diligencia.tarea.tareaRespuestas.length === 0
           ) {
            return true;
        }
        return false;
    }

    responderTarea() {
        console.log("CREAR COMPONENTE PARA RESPONDER");
        let idDiligenciaConfig = this.route.snapshot.params.idDiligenciaConfig ? this.route.snapshot.params.idDiligenciaConfig : null;
        let idConfig = this.route.snapshot.params.idConfig ? this.route.snapshot.params.idConfig : null;
        let idExpediente = this.route.snapshot.params.idExpediente ? this.route.snapshot.params.idExpediente : null;
        this.router.navigate(['/diligencias/' + idConfig+'/'+ idExpediente+'/'+ idDiligenciaConfig+'/responder'+'/'+ this.diligencia.id]);

        /*
        const destinatario = this.route.snapshot.params['destinatario'];
        const idTarea = this.diligencia.tarea.id;
        const tareaDiligenciaConfig = this.diligencia.tarea.detalle.idDiligenciaConfig;
        const tareaIdNegocio = this.diligencia.tarea.idNegocio;
        if (this.isExterna) {
            this.routing.navigateTo(`/diligencia/${destinatario}/nueva/responder-externa/${idTarea}/${tareaDiligenciaConfig}/${tareaIdNegocio}`);
        } else {
            const idExpediente = this.diligencia.expediente.id;
            this.routing.navigateTo(`/diligencia/${destinatario}/nueva/responder/${idExpediente}/${idTarea}/${tareaDiligenciaConfig}/${tareaIdNegocio}`);
        }
        */
    }

    validarEnviarRespuesta() {
        const username = this.evkSecurity.getUsuarioInfo().username;
        // tslint:disable-next-line:max-line-length
        if (!this.expediente.enviadaComoRespuesta
            && this.expediente.idDiligenciaPadre
            && this.diligenciaPadre
            && this.diligenciaPadre.estadoTareaActivo
            && this.diligenciaPadre.estadoTareaActivo.estado.nombre === 'ASIGNADA'
            && this.diligenciaPadre.tarea.usuarioAsignado.value === username
            && this.diligenciaPadre.tarea.tareaRespuestas.length === 0
            && !this.expediente.enviadaComoRespuesta
           ) {
            return true;
        }
        return false;
    }

    enviarRespuesta(){
        const confirmDialog = this.messageCrudService.openConfirmDialog({
            warn: '¿Está seguro de responder con esta actuación?',
            goonbtn: 'Aceptar'
        });
        confirmDialog.componentInstance.resolveEvent.subscribe(() => {
            this.evkResponderDiligenciaService.edit(this.diligencia).pipe(take(1)).subscribe(response => {
                this.messageCrudService.snackbarMessage('Actuación respondida de forma exitosa.');
                confirmDialog.close();
                this.router.navigate(['/diligencias']);
            }, error => {
                this.messageCrudService.snackbarMessage('No se ha podido responder la actuación. ' + error);
                confirmDialog.close();
            });
        });
    }

    canSolicitarAutorizacion(): boolean {
        if (this.diligencia.estadoTareaActivo.usuarioAsignado &&
            this.diligencia.estadoTareaActivo.usuarioAsignado.value !== this.username) {
            return false;
        }
        return true;
    }

    validarSolicitarAutorizacionSimple(){
        if (this.diligenciaConfig
            && this.diligenciaConfig.clasificacionDiligencia
            && this.diligenciaConfig.clasificacionDiligencia.tipo === 'SIMPLE'
            && this.diligencia
            && this.diligencia.estadoTareaActivo
            && this.diligencia.estadoTareaActivo.estado.nombre === 'POR AUTORIZAR'
            && this.canSolicitarAutorizacion()
           ) {
            return true;
        }
        return false;
    }

    validarSolicitarAutorizacionSolicitud(){
        if (this.diligenciaConfig
            && this.diligenciaConfig.clasificacionDiligencia
            && this.diligenciaConfig.clasificacionDiligencia.tipo === 'SOLICITUD'
            && this.diligenciaConfig.tipoOrganizacionAutorizador
            && this.diligenciaConfig.tipoOrganizacionAutorizador.length > 0
            && this.diligencia
            && this.diligencia.estadoTareaActivo
            && this.diligencia.estadoTareaActivo.estado.nombre === 'CREADA'
            && this.canSolicitarAutorizacion()
           ) {
            return true;
        }
        return false;
    }

    mostrarSolicitarAutorizacionDialog() {
        const dialogRef = this.dialog.open(SolicitarAutorizacionCreateComponent, {
            panelClass: 'create-component-dialog',
            width: '90%',
            disableClose: true,
            data: {
                diligencia: this.diligencia,
                diligenciaConfig: this.diligenciaConfig,

            }
        });

        dialogRef.afterClosed().pipe(take(1)).subscribe(response => {
            if (response) {
                this.router.navigate(['/diligencias']);
            }
        });
    }

    firmarAndSolicitarAutorizacionesDialog() {
        if (this.diligenciaConfig.requiereFirmaE) {
            if (!this.evkSecurity.getUsuarioInfo().persona.rfc || this.evkSecurity.getUsuarioInfo().persona.rfc === '') {
                this.messageCrudService.snackbarMessage('El usuario no cuenta con RFC');
                return;
            }
            this.finalizarService.validCadenaOriginarRfc({...this.diligencia})
                .pipe(take(1))
                .subscribe((value: any) => {
                    this.showModalFirmaEAndExecuteAnyMethod(value, accion => this.mostrarSolicitarAutorizacionDialog(), 'Diligencia');
                });
        } else {
            this.mostrarSolicitarAutorizacionDialog();
        }
    }

    canValidarAutorizarRol() {
        return true;//AuthUtils.hasRol('AUTORIZADOR');
    }

    numeroAutorizaciones(tarea) {
        return tarea.estadoTarea.filter(({estado: {nombre}}) => nombre === 'EN AUTORIZACIÓN').length;
    }

    viewOpcMultipleAuto() {
        this.organizacionUsuario = this.evkSecurity.getUsuarioInfo().organizacionLogica ? this.evkSecurity.getUsuarioInfo().organizacionLogica.id : this.evkSecurity.getUsuarioInfo().organizacionFisica.id;

        const idOrganizacion = this.evkSecurity.getUsuarioInfo().organizacionLogica ? this.evkSecurity.getUsuarioInfo().organizacionLogica.id : this.evkSecurity.getUsuarioInfo().organizacionFisica.id;
        this.catalogosService.getTiposOrganizacionesByOrganizacionOrigenAndTipoConfiguracion(idOrganizacion, 'AUTORIZACION').pipe(take(1)).subscribe(value => {
            this.multipleAut = value.length > 1;
        });
    }

    public validarAutorizar(){
        if (
            this.diligencia
            && this.diligencia.estadoTareaActivo
            && this.diligencia.estadoTareaActivo.estado.nombre === 'EN AUTORIZACIÓN'
            && (
                  (
                     this.diligencia.estadoTareaActivo?.usuarioAsignado === null
                     && this.diligencia.estadoTareaActivo.organizacion.value === this.organizacionUsuario
                  )
                  ||
                 (
                    this.diligencia.estadoTareaActivo.usuarioAsignado.value === this.username
                 )
            )
            && this.canValidarAutorizarRol()
            && this.numeroAutorizaciones(this.diligencia.tarea) >= 1
            && !this.multipleAut
           ) {
            return true;
        }
        return false;
    }

    autorizarDilgiencia() {
        if (!this.evkSecurity.getUsuarioInfo().persona.rfc || this.evkSecurity.getUsuarioInfo().persona.rfc === '') {
            this.messageCrudService.snackbarMessage('El usuario no cuenta con RFC');
            return;
        }
        this.catalogosService.getTipoOrganizacionByOrganizacionById(this.diligencia.estadoTareaActivo.organizacion.value).subscribe((response: any) => {
            console.log("autorizarDilgiencia");
            if (response && response.firma) {
                this.finalizarService.validCadenaOriginarRfc({...this.diligencia})
                    .pipe(take(1))
                    .subscribe((value: any) => {
                        this.showModalFirmaEAndExecuteAnyMethod(value, accion => this.openDialogAutorizar(), 'Autorización');
                    });
            } else {
                this.openDialogAutorizar();
            }
        });
    }

    openDialogAutorizar() {
        const confirmDialog = this.messageCrudService.openConfirmDialog({
            warn: '¿Está seguro de autorizar la actuación?',
            goonbtn: 'Autorizar',
        });
        confirmDialog.componentInstance.resolveEvent.subscribe(() => {
            this.evkDiligenciaAutorizarService.edit(this.diligencia).subscribe((response) => {
                    this.messageCrudService.snackbarMessage('La actuación se autorizo exitosamente');
                    confirmDialog.close();
                    this.router.navigate(['/diligencias']);
                },
                (error) => {
                    console.log('error', error);
                    confirmDialog.close();
                }
            );
        });
    }

    public validarMultipleAutorizar(){
        if (
            this.diligencia
            && this.diligencia.estadoTareaActivo
            && this.diligencia.estadoTareaActivo.estado.nombre === 'EN AUTORIZACIÓN'
            && (
                  (
                     this.diligencia.estadoTareaActivo?.usuarioAsignado === null
                     && this.diligencia.estadoTareaActivo.organizacion.value === this.organizacionUsuario
                  )
                  ||
                 (
                    this.diligencia.estadoTareaActivo.usuarioAsignado.value === this.username
                 )
            )
            && this.canValidarAutorizarRol()
            && this.multipleAut
           ) {
            return true;
        }
        return false;
    }

    solicitarMultipleAutorizacion() {
        this.catalogosService.getOrganizacionById(this.diligencia.tarea.organizacion.value).subscribe(({tipoOrganizacion: {firma}}: any) => {
            if (firma) {
                this.finalizarService.validCadenaOriginarRfc({...this.diligencia})
                    .pipe(take(1))
                    .subscribe((value: any) => {
                        this.showModalFirmaEAndExecuteAnyMethod(value, accion => this.openDialogEnAutorizar(this.diligencia.tarea, false), 'Autorización');
                    });
            } else {
                this.mostrarModalParaAutorizacionMultiple();
            }
        });

    }

    openDialogEnAutorizar(tarea: any, automatico?: boolean) {
        tarea.detalle['id'] = tarea.idNegocio;
        const dialog = this.dialog.open(EnAutorizacionDiligenciaCreateComponent, {
            panelClass: 'create-component-dialog',
            width: '900px',
            data: {
                organizacionOrigen: tarea['organizacion'],
                diligencia: this.diligencia,
                formatoAutomatico: automatico
            },
        });
        dialog.afterClosed().subscribe((result) => {
            if (result) {
                this.messageCrudService.snackbarMessage('¡Solicitud de autorización enviada con exito!');
                this.router.navigate(['/diligencias']);
            }
        });
    }

    mostrarModalParaAutorizacionMultiple() {
        console.log('listo para solicitar mas una autorización');
    }


    public validarRechazarAutorizar(){
        if (
            this.diligencia
            && this.diligencia.estadoTareaActivo
            && this.diligencia.estadoTareaActivo.estado.nombre === 'EN AUTORIZACIÓN'
            && (
                  (
                     this.diligencia.estadoTareaActivo?.usuarioAsignado === null
                     && this.diligencia.estadoTareaActivo.organizacion.value === this.organizacionUsuario
                  )
                  ||
                 (
                    this.diligencia.estadoTareaActivo.usuarioAsignado.value === this.username
                 )
            )
            && this.canValidarAutorizarRol()
           ) {
            return true;
        }
        return false;
    }

    rechazarAutorizacion() {
        const dialog = this.dialog.open(MotivoRechazoCreateComponent, {
            panelClass: 'rechazar-component-dialog',
            width: '900px',
            data: {
                diligencia: this.diligencia,
            }
        });
        dialog.afterClosed().subscribe((result) => {
            if (result) {
                this.messageCrudService.snackbarMessage('La actuación fue rechazada con éxito');
                this.router.navigate(['/diligencias']);
            }
        });
    }

}
